import { List } from '@mui/material';
import styled from '@emotion/styled';
import { spacing } from '@/theme/tokens';

const StyledSidebarList = styled(List)`
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: ${spacing[4]};
`;

interface SidebarStyledListProps {
    children: React.ReactNode;
}

export default function SidebarStyledList({ children }: SidebarStyledListProps) {
    return <StyledSidebarList>{children}</StyledSidebarList>;
}
